
angular.module('bmsApp.crm.customer').controller('CustomerViewCtrl', [
	'$window',
	'$state',
	'$scope',
	'$ngBootbox',
	'notify',
	'ngTableParams',
	'EmailSvc',
	'ActivitySvc',
	'NoteSvc',
	'MMJobSvc',
	'TGJobSvc',
	'SMJobSvc',
	'ProspectSvc',
	'ContactSvc',
	'SiteSvc',
	'AccountingSvc',
	'CustomerSvc',
	'ReminderSvc', function (
		$window,
		$state,
		$scope,
		$ngBootbox,
		notify,
		ngTableParams,
		EmailSvc,
		ActivitySvc,
		NoteSvc,
		MMJobSvc,
		TGJobSvc,
		SMJobSvc,
		ProspectSvc,
		ContactSvc,
		SiteSvc,
		AccountingSvc,
		CustomerSvc,
		ReminderSvc) {

		// tab functions to be inherited and overridden by child controllers
		$scope.tabs = {
			statement: {
				select: function () {},
				reload: function () {}
			},
			contacts: {
				select: function () {},
				loadAdditional: function () {},
				showForm: function () {},
				confirmPrimary: function () {}
			},
			sites: {
				select: function () {},
				loadAdditional: function () {},
				showForm: function () {},
				confirmPrimary: function () {}
			},
			correspondences: {
				select: function () {}
			},
			notes: {
				activeObjectType: 'App\\Models\\Crm\\Customer',
				activeObjectId: $state.params.customerId,
				jobs: null,
				job: null,
				view: 'customer',
				jobDisabled: true
			}
		};

		var customerId = $state.params.customerId;
		$scope.customerId = customerId;
		var loadCustomer = function () {
			$scope.loading = true;
			CustomerSvc.read(customerId)
				.then(function (response) {
					$scope.customer = response.data.customer;
					$scope.loading = false;
				});
		};
		$scope.loadCustomer = loadCustomer;
		loadCustomer();

		$scope.note = {
			api: {}
		};

		// Action menu links

		$scope.addActivity = function () {
			// empty activity with this customer pre-selected
			var activity = {
				customer: $scope.customer
			};
			ActivitySvc.showSaveModal(activity);
		};

		$scope.addRepeatEnquiry = function() {
			CustomerSvc.showRepeatEnquiryModal($scope.customer).then((response) => {

			});
		};

		$scope.addProspect = function () {
			$state.go('main.crm.prospect.index.create', {contactId: $scope.customer.primary_contact.id});
		};

		$scope.addNote = function () {
			var note = {
				object_type: 'App\\Models\\Crm\\Customer',
				object_id: $scope.customer.id
			};
			NoteSvc.showSaveModal(note);
		};

		$scope.convertToQuote = function(event, quote) {
			event.stopPropagation();
			if ($scope.isMM()) {

			}
			else if ($scope.isTG()) {
				var params = {
					id: quote.id
				};
				TGJobSvc.convertToQuote(params).then(function(response) {
					angular.extend(quote, response.data.tg_job);
				});
			}
		};

		$scope.paymentReceipt = function () {
			if (!$scope.paymentReceiptLoading) {
				AccountingSvc.showPaymentReceiptModal($scope.customer)
					.then(function (modalResult) {
						$scope.paymentReceiptLoading = true;
						AccountingSvc.savePaymentReceipt(modalResult.customerPayment)
							.then(function (response) {
								notify({
									message: 'Bank receipt saved'
								});
								loadCustomer();
								$scope.tabs.statement.reload();
							}, function (error) {
								notify({
									message: error,
									classes: 'error'
								});
							})
							.finally(function () {
								$scope.paymentReceiptLoading = false;
							});
					});
			}
		};

		// Active tab states

		$scope.tabsActive = {
			jobHistory: true,
			statement: false,
			prospects: false,
			contacts: false,
			sites: false,
			quotes: false,
			notes: false,
			correspondences: false
		};

		var setActiveTab = function (name) {
			angular.forEach($scope.tabsActive, function (value, key) {
				$scope.tabsActive[key] = String(key) === name;
			});
		};
		$scope.setActiveTab = setActiveTab;

		$scope.$on('contactsUpdated', function () {
			loadCustomer();
			loadAdditionalContacts();
			setActiveTab('contacts');
		});

		$scope.$on('notesUpdated', function () {
			setActiveTab('notes');
		});

		// Active tab callbacks

		$scope.tabJobHistory = function () {

			if (angular.isUndefined($scope.mmJobs)) {
				$scope.mmJobs = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						reference: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.mmJobsLoading = true;
						MMJobSvc.jobsByCustomer(customerId, params.$params)
							.then(function (response) {
								$scope.mmJobTotal = response.data.job_total_count;
								params.total(response.data.job_filtered_count);
								$defer.resolve(response.data.job_collection);
								$scope.mmJobsLoading = false;
							});
					}
				});
			}

			if (angular.isUndefined($scope.tgJobs)) {
				$scope.tgJobs = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						reference: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.tgJobsLoading = true;
						TGJobSvc.jobsByCustomer(customerId, params.$params)
							.then(function (response) {
								$scope.tgJobTotal = response.data.tg_job_total_count;
								params.total(response.data.tg_job_filtered_count);
								$defer.resolve(response.data.tg_job_collection);
								$scope.tgJobsLoading = false;
							});
					}
				});
			}

			if (angular.isUndefined($scope.smJobs)) {
				$scope.smJobs = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						reference: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.mmJobsLoading = true;
						SMJobSvc.jobsByCustomer(customerId, params.$params)
							.then(function (response) {
								$scope.smJobTotal = response.data.sm_job_total_count;
								params.total(response.data.sm_job_filtered_count);
								$defer.resolve(response.data.sm_job_collection);
								$scope.smJobsLoading = false;
							});
					}
				});
			}
		};

		$scope.tabProspects = function () {
			if (angular.isUndefined($scope.prospects)) {
				$scope.prospects = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						tstamp: 'desc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.prospectsLoading = true;
						ProspectSvc.byCustomer(customerId, params.$params)
							.then(function (response) {
								$scope.prospectTotal = response.data.prospect_total_count;
								params.total(response.data.prospect_filtered_count);
								$defer.resolve(response.data.prospect_collection);
								$scope.prospectsLoading = false;
							});
					}
				});
			}
		};

		$scope.tabQuotes = function () {
			if (angular.isUndefined($scope.mmQuotes)) {
				$scope.mmQuotes = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						id: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.mmQuotesLoading = true;
						MMJobSvc.quotesByCustomerOrCustomerEnquiry(customerId, params.$params)
							.then(function (response) {
								$scope.mmQuoteTotal = response.data.job_total_count;
								params.total(response.data.job_filtered_count);
								$defer.resolve(response.data.job_collection);
								$scope.mmQuotesLoading = false;
							});
					}
				});
			}

			if (angular.isUndefined($scope.tgQuotes)) {
				$scope.tgQuotes = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						id: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.tgQuotesLoading = true;
						TGJobSvc.quotesByCustomerOrCustomerEnquiry(customerId, params.$params, false)
							.then(function (response) {
								$scope.tgQuoteTotal = response.data.tg_job_total_count;
								params.total(response.data.tg_job_filtered_count);
								$defer.resolve(response.data.tg_job_collection);
								$scope.tgQuotesLoading = false;
							});
					}
				});
			}

			if (angular.isUndefined($scope.smQuotes)) {
				$scope.smQuotes = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						id: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						$scope.smQuotesLoading = true;
						SMJobSvc.quotesByCustomerOrCustomerEnquiry(customerId, params.$params)
							.then(function (response) {
								$scope.smQuoteTotal = response.data.sm_job_total_count;
								params.total(response.data.sm_job_filtered_count);
								$defer.resolve(response.data.sm_job_collection);
								$scope.smQuotesLoading = false;
							});
					}
				});
			}
		};

		$scope.tabNotes = function () {
			if ($scope.tabs.notes.jobs == null) {
				$scope.getJobOptions();
			}
			$scope.note.api.showNotes();
		};

		$scope.visitSchedule = {
			date: null
		};

		$scope.visitScheduleFormvalidatorconfig = {
			submitHandler: function () {
				$ngBootbox.confirm('Would you like to add this to notes so it\'s easily emailed to the customer?')
					.then(function () {
						$window.open('merrymaids/visit-schedule/' + $scope.customer.id + '?date=' + $scope.visitSchedule.date + '&save=1', '_blank');
					}, function() {
						$window.open('merrymaids/visit-schedule/' + $scope.customer.id + '?date=' + $scope.visitSchedule.date + '&save=0', '_blank');
					});
			},
			errorPlacement: function (error) {
				error.appendTo('#visit-schedule-errors');
			},
			errorContainer: '#visit-schedule-errors'
		};

		$scope.emailForm = function (emailAddress, objectType, objectId) {
			var email = {
				to: emailAddress,
				object_type: objectType,
				object_id: objectId
			};
			EmailSvc.showSendModal(email, $scope.customer);
		};

		$scope.mmJobRowClicked = function (mmJob) {
			$state.go('main.merrymaids.job.read', {
				jobId: mmJob.id,
			});
		};

		$scope.tgJobRowClicked = function (tgJob) {
			$state.go('main.trugreen.job.index.view', {
				jobId: tgJob.id,
			});
		};

		$scope.prospectRowClicked = function (prospect) {
			$state.go('main.crm.prospect.index.view', {
				prospectId: prospect.id
			});
		};

		$scope.mmQuoteRowClicked = function (mmQuote) {
			if (mmQuote.converted) {
				$scope.mmJobRowClicked(mmQuote);
			}
			else {
				$state.go('main.merrymaids.quote.read', {
					jobId: mmQuote.id,
				});
			}
		};

		$scope.tgQuoteRowClicked = function (tgQuote) {
			$state.go('main.trugreen.quote.index.view', {quoteId: tgQuote.id});
		};

		$scope.smQuoteRowClicked = function (smQuote) {
			$state.go('main.sm.quote.index.view', {quoteId: smQuote.id});
		};

		$scope.showReminderModal = function () {
			ReminderSvc.showReminderModal('App\\Models\\Crm\\Customer', $scope.customer.id);
		};

		$scope.getJobOptions = function() {
			if ($scope.isMM()) {
				MMJobSvc.jobsByCustomer(customerId, {}).then(function(response) {
					$scope.tabs.notes.jobs = response.data.job_collection;
					if ($scope.tabs.notes.jobs.length > 0) {
						$scope.tabs.notes.job = $scope.tabs.notes.jobs[0].id;
						$scope.tabs.notes.jobDisabled = false;
					}

				});
			}
			else if ($scope.isTG()) {
				TGJobSvc.jobsByCustomer(customerId, {}).then(function(response) {
					$scope.tabs.notes.jobs = response.data.tg_job_collection;
					if ($scope.tabs.notes.jobs.length > 0) {
						$scope.tabs.notes.job = $scope.tabs.notes.jobs[0].id;
						$scope.tabs.notes.jobDisabled = false;
					}

				});
			}
			else if ($scope.isSM()) {
				SMJobSvc.jobsByCustomer(customerId, {}).then(function(response) {
					$scope.tabs.notes.jobs = response.data.sm_job_collection;
					if ($scope.tabs.notes.jobs.length > 0) {
						$scope.tabs.notes.job = $scope.tabs.notes.jobs[0].id;
						$scope.tabs.notes.jobDisabled = false;
					}

				});
			}

		};

		$scope.showCustomerNotes = function() {
			$scope.tabs.notes.activeObjectType = 'App\\Models\\Crm\\Customer';
			$scope.tabs.notes.activeObjectId = customerId;
		};

		$scope.showJobNotes = function() {
			var jobType = undefined;
			if ($scope.isMM()) {
				jobType = 'App\\Models\\Merrymaids\\Job';
			}
			else if ($scope.isTG()) {
				jobType = 'App\\Models\\Trugreen\\Job';
			}
			else if ($scope.isSM()) {
				jobType = 'App\\Models\\Sm\\Job'
			}

			if (angular.isDefined(jobType)) {
				$scope.tabs.notes.activeObjectType = jobType;
				$scope.tabs.notes.activeObjectId = $scope.tabs.notes.job;
			}

		};

	}]);
